<template>
  <form class="form-container" :class="{'form-container--half': halfSize}" @submit.prevent="onSubmit" novalidate>
    <slot></slot>
  </form>
</template>

<script>
export default {
  name: 'customForm',
  props: {
    handleSubmit: {
      type: Function
    },
    halfSize: {
      type: Boolean
    }
  },
  methods: {
    onSubmit: function () {
      if (typeof this.handleSubmit === 'function') {
        this.handleSubmit()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Form.vue?d7d84504